export enum EVENT_TYPE_ENUM {
    SUCCESS = 'Success',
    CLOSE = 'Close',
    SUBMIT = 'Submit',
    RESET = 'Reset',
    DISCARD = 'Discard',
    CANCEL = 'Cancel',
    PENDING = 'Pending',
    ADD = 'Add',
    CHECKER = "Checker",
    REMOVE = 'Remove',
    SEND_INVOICE = "Send_invoice",
    VIEW_DETAILS = 'View_details',
    SEND_VERIFICATION = 'Send_verification',
    ADD_COUNTER_PARTY = 'Add_counter_party',
    SHOW_SIDEBARS = 'Show_Side_Bars',
    HIDE_SIDEBARS = 'Hide_Side_Bars',
    VIEW_REMARK_ALL = 'View_remark_all',
    UPDATE = 'Update',
    UPLOAD_TEMPLATE='Upload_Template',
    GENERATE_INVOICE='Generate Invoice',
    PREVIEW_INVOICE = 'Preview',
    VESSEL_DETAILS = 'Vessel Details',
    REQUEST_EUA = "Request Eua",
    APPROVE= "Approve",
    REJECT = "Reject",
    INVOICE = "Invoice",
    SEND_REMINDER = "Send reminder",
    ADD_MANUALLY = "Add_manually",
    PLACE_ORDER = "Place_order",
    CANCEL_REQUEST="Cancel_requests",
    ALLOCTAE="Allocate",
    DELIVER_EUAS="Deliver EUAs",
    CONVERSION="Conversion",
    ALLOCATE="Allocate",
    SELECT_ALL="SELECT_ALL",
    EXPORT_EXCEL="EXPORT_EXCEL"
}

export enum ROLES {
    MAKER = 'Maker',
    CHECKER = 'Checker'
}

export enum STATUS_ENUM{
    PENDING = 'Pending',
    APPROVED = 'Approved',
    REJECTED = 'Rejected',
    RECEIVED = 'Received',
    COMPLETED = 'Completed',
    CANCELED = 'Cancelled',
    IN_PROGRESS = 'In Progress',
    INACTIVE = 'Inactive',
    ACTIVE = 'Active',
    ORDERED = 'Ordered',
    INVOICED = 'Invoiced',
    UNINVOICED = 'Uninvoiced',
    UNALLOCATED = 'Unallocated',
    ALLOCATED = 'Allocated',
    SETTLED = 'Settled',
    PARTIALLY_SETTLED = 'Partially Settled',
    DELAYED= 'Delayed',
    DISPUTED = 'Disputed',
    SUBMITTED_FOR_REVIEW = 'Submitted for Review',
    TO_BE_PAID = 'To be Paid',
    PARTIALLY_RECEIVED = 'Partially Received',
    EXECUTED = 'Executed', 
    PARTIALLY_ORDERED = 'Partially Ordered',
    ALLOCATION_PENDING = 'Allocation Pending',
    APPROVAL_PENDING = 'Approval Pending'
}